import React, { useState } from 'react';
import { Form, Row, Col, Card, Spinner, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

var TIPOS_CONTA = [
  { value: 1, label: '1 - Cliente Factoring' },
  { value: 2, label: '2 - Cliente Comércio' },
  { value: 3, label: '3 - Despesa' },
  { value: 4, label: '4 - Fornecedor' },
  { value: 5, label: '5 - Banco' },
  { value: 6, label: '6 - Interna' },
  { value: 7, label: '7 - Receita' },
  { value: 8, label: '8 - Funcionário/Prest.Serviço' },
];

var STATUS_CONTA = [
  { value: '0', label: 'Ativo' },
  { value: '1', label: 'Inativo' },
  { value: '2', label: 'Negativado' },
];

// Fonte: UManutContas.dfm, RxDBComboBox2 — Items da propriedade
var ACEITA_CONTA = [
  { value: 'N', label: 'Negócio' },
  { value: 'L', label: 'Liquidação' },
  { value: 'A', label: 'Ambos' },
  { value: 'E', label: 'Nenhum' },
  { value: 'D', label: 'Não lançar devedor' },
];

var FormDadosGerais = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;
  var isNovo = _ref.isNovo;
  var onTipoChange = _ref.onTipoChange;
  var onGeChange = _ref.onGeChange;
  var codigoLoading = _ref.codigoLoading;

  var ges = (lookups && lookups.ges) ? lookups.ges : [];
  var ramos = (lookups && lookups.ramos) ? lookups.ramos : [];
  var responsaveis = (lookups && lookups.responsaveis) ? lookups.responsaveis : [];
  var tabelasPrecos = (lookups && lookups.tabelasPrecos) ? lookups.tabelasPrecos : [];
  var gruposContas = (lookups && lookups.gruposContas) ? lookups.gruposContas : [];

  var [aberto, setAberto] = useState(true);

  var getError = function(campo) {
    return formik.touched[campo] && formik.errors[campo] ? formik.errors[campo] : null;
  };

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados Gerais</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Row>
          <Col md={3} className="mb-3">
            <Form.Group controlId="codigo_grupo_empresa" className="mb-0">
              <Form.Label className="small mb-1">Grupo de Empresa *</Form.Label>
              <Select
                placeholder="Selecione o GE..."
                options={ges}
                value={ges.find(function(g) { return g.value === formik.values.codigo_grupo_empresa; }) || null}
                onChange={function(opt) {
                  var val = opt ? opt.value : '';
                  formik.setFieldValue('codigo_grupo_empresa', val);
                  if (onGeChange && val) { onGeChange(val); }
                }}
                isDisabled={!modoEdicao || !isNovo || lookupsLoading}
                isLoading={lookupsLoading}
                noOptionsMessage={function() { return 'Nenhum GE encontrado'; }}
              />
              {getError('codigo_grupo_empresa') && (
                <small className="text-danger">{getError('codigo_grupo_empresa')}</small>
              )}
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="tipo" className="mb-0">
              <Form.Label className="small mb-1">Tipo *</Form.Label>
              <Select
                placeholder="Selecione o tipo..."
                options={TIPOS_CONTA}
                value={TIPOS_CONTA.find(function(t) { return t.value === formik.values.tipo; }) || null}
                onChange={function(opt) {
                  var val = opt ? opt.value : '';
                  formik.setFieldValue('tipo', val);
                  if (onTipoChange && val) {
                    onTipoChange(val);
                  }
                }}
                isDisabled={!modoEdicao || !isNovo}
                noOptionsMessage={function() { return 'Nenhum tipo encontrado'; }}
              />
              {getError('tipo') && (
                <small className="text-danger">{getError('tipo')}</small>
              )}
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="grupo" className="mb-0">
              <Form.Label className="small mb-1">
                Categoria
                {(formik.values.tipo === 3 || formik.values.tipo === 7) && ' *'}
              </Form.Label>
              <Select
                placeholder="Selecione..."
                options={gruposContas}
                value={gruposContas.find(function(g) { return g.value === formik.values.grupo; }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('grupo', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao}
                isClearable
                noOptionsMessage={function() { return 'Nenhuma categoria'; }}
              />
              {getError('grupo') && (
                <small className="text-danger">{getError('grupo')}</small>
              )}
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="codigo_contabil" className="mb-0">
              <Form.Label className="small mb-1">Código Contábil</Form.Label>
              <Form.Control
                type="text"
                size="sm"
                value={formik.values.codigo_contabil !== null && formik.values.codigo_contabil !== undefined ? formik.values.codigo_contabil : ''}
                onChange={formik.handleChange}
                name="codigo_contabil"
                disabled={!modoEdicao}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={2} className="mb-3">
            <Form.Group controlId="codigo_conta" className="mb-0">
              <Form.Label className="small mb-1">
                Código *
                {codigoLoading && <Spinner animation="border" size="sm" className="ml-1" />}
              </Form.Label>
              <Form.Control
                type="number"
                size="sm"
                value={formik.values.codigo_conta !== null && formik.values.codigo_conta !== undefined ? formik.values.codigo_conta : ''}
                onChange={formik.handleChange}
                name="codigo_conta"
                disabled={!modoEdicao || !isNovo || codigoLoading}
                isInvalid={!!getError('codigo_conta')}
                placeholder={codigoLoading ? 'Carregando...' : ''}
              />
              <Form.Control.Feedback type="invalid">{getError('codigo_conta')}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-3">
            <Form.Group controlId="apelido_conta" className="mb-0">
              <Form.Label className="small mb-1">Apelido *</Form.Label>
              <Form.Control
                type="text"
                size="sm"
                value={formik.values.apelido_conta !== null && formik.values.apelido_conta !== undefined ? formik.values.apelido_conta : ''}
                onChange={formik.handleChange}
                name="apelido_conta"
                maxLength={30}
                disabled={!modoEdicao}
                isInvalid={!!getError('apelido_conta')}
              />
              <Form.Control.Feedback type="invalid">{getError('apelido_conta')}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="data_validade" className="mb-0">
              <Form.Label className="small mb-1">Data de Validade *</Form.Label>
              <Form.Control
                type="date"
                size="sm"
                value={formik.values.data_validade !== null && formik.values.data_validade !== undefined ? formik.values.data_validade : ''}
                onChange={formik.handleChange}
                name="data_validade"
                disabled={!modoEdicao}
                isInvalid={!!getError('data_validade')}
              />
              <Form.Control.Feedback type="invalid">{getError('data_validade')}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="data_cadastro" className="mb-0">
              <Form.Label className="small mb-1">Data de Cadastro</Form.Label>
              <Form.Control
                type="text"
                size="sm"
                value={formik.values.data_cadastro !== null && formik.values.data_cadastro !== undefined ? formik.values.data_cadastro : ''}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={4} className="mb-3">
            <Form.Group controlId="codigo_tabela" className="mb-0">
              <Form.Label className="small mb-1">Tabela de Preços</Form.Label>
              <Form.Control
                as="select"
                size="sm"
                name="codigo_tabela"
                value={formik.values.codigo_tabela !== null && formik.values.codigo_tabela !== undefined ? formik.values.codigo_tabela : ''}
                onChange={function(e) {
                  formik.setFieldValue('codigo_tabela', e.target.value ? parseInt(e.target.value, 10) : null);
                }}
                disabled={!modoEdicao}
              >
                <option value="">Selecione...</option>
                {tabelasPrecos.map(function(t) {
                  return <option key={t.value} value={t.value}>{t.label}</option>;
                })}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-3">
            <Form.Group controlId="codigo_ramo" className="mb-0">
              <Form.Label className="small mb-1">Ramo *</Form.Label>
              <Select
                placeholder="Selecione o ramo..."
                options={ramos}
                value={ramos.find(function(r) { return r.value === formik.values.codigo_ramo; }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('codigo_ramo', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao || lookupsLoading}
                isLoading={lookupsLoading}
                noOptionsMessage={function() { return 'Nenhum ramo'; }}
              />
              {getError('codigo_ramo') && (
                <small className="text-danger">{getError('codigo_ramo')}</small>
              )}
            </Form.Group>
          </Col>
          <Col md={4} className="mb-3">
            <Form.Group controlId="aprovacao_2" className="mb-0">
              <Form.Label className="small mb-1">Responsável *</Form.Label>
              <Select
                placeholder="Selecione..."
                options={responsaveis}
                value={responsaveis.find(function(r) { return r.value === formik.values.aprovacao_2; }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('aprovacao_2', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao || lookupsLoading}
                isLoading={lookupsLoading}
                noOptionsMessage={function() { return 'Nenhum responsável'; }}
              />
              {getError('aprovacao_2') && (
                <small className="text-danger">{getError('aprovacao_2')}</small>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={2} className="mb-3">
            <Form.Group controlId="status" className="mb-0">
              <Form.Label className="small mb-1">Status *</Form.Label>
              <Select
                placeholder="Selecione..."
                options={STATUS_CONTA}
                value={STATUS_CONTA.find(function(s) { return s.value === formik.values.status; }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('status', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao}
                noOptionsMessage={function() { return 'Nenhum status'; }}
              />
              {getError('status') && (
                <small className="text-danger">{getError('status')}</small>
              )}
            </Form.Group>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Group controlId="permissao_neg_mata" className="mb-0">
              <Form.Label className="small mb-1">Aceita *</Form.Label>
              <Select
                placeholder="Selecione..."
                options={ACEITA_CONTA}
                value={ACEITA_CONTA.find(function(a) { return a.value === formik.values.permissao_neg_mata; }) || null}
                onChange={function(opt) {
                  formik.setFieldValue('permissao_neg_mata', opt ? opt.value : '');
                }}
                isDisabled={!modoEdicao}
                noOptionsMessage={function() { return 'Nenhuma opção'; }}
              />
              {getError('permissao_neg_mata') && (
                <small className="text-danger">{getError('permissao_neg_mata')}</small>
              )}
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormDadosGerais;
